import React, { useState, useEffect } from "react";
import Conect from "../../../../../Api/Conect";
import moment from "moment";
import "./VehiclesManager.css"; // Arquivo de estilização

const initialFormState = {
    id: "",
    plate: "",
    description: "",
    year: "",
    model: "",
    brand: "",
    odometer: "",
    hourmeter: "",
    customers_id: "",
    driver_id: "",
    equipament_id: "",
    vehicle_type: "",
};

const VehiclesManager = () => {
    // const history = useNavigate();
    const token = localStorage.getItem("rastoken");
    const [vehicles, setVehicles] = useState([]);
    const [vehicleTypes, setVehicleTypes] = useState([]);
    const [equips, setEquips] = useState([]);
    const [drivers, setDrivers] = useState([]);
    const [clients, setClients] = useState([]);
    const [form, setForm] = useState(initialFormState);
    const [editing, setEditing] = useState(false);
    const [showModal, setShowModal] = useState(false);

    // eslint-disable-next-line
    useEffect(() => {
        fetchVehicles();
        // eslint-disable-next-line
    }, []);

    const fetchVehicles = async () => {
        try {
            const { data: vehiclesData } = await Conect.get(`/dmVoaWNsZWxpc3Q=${token}`);
            const { data: typesData } = await Conect.get(`/dmVoaWNsZXN0eXBlbGlzdA==${token}`);
            const { data: equipsData } = await Conect.get(`/ZXF1aXBsaXN0${token}`);
            const { data: cliData } = await Conect.get(`/Y29zdHVtZXJzbGlzdA==${token}`);
            const { data: driverData } = await Conect.get(`/ZHJpdmVybGlzdA==${token}`);
            const mergedData = mergevehiclesWithType(vehiclesData.data, typesData.data, equipsData.data, cliData.data);

            setVehicleTypes(typesData.data);
            setVehicles(mergedData);
            setEquips(equipsData.data);
            setClients(cliData.data);
            setDrivers(driverData.data);
        } catch (error) {
            console.error("Error fetching vehicles:", error);
        }
    };

    const mergevehiclesWithType = (vehicles, type, equips, client) => {
        return vehicles.map((types) => ({
            ...types,
            type: type.find((tp) => tp.id === types.vehicle_type)?.description || "Desconhecido",
            serial: equips.find((eq) => eq.id === types.equipament_id)?.serial || "Desconhecido",
            cli_name: client.find((cli) => cli.id === types.customers_id)?.name || "Desconhecido",
        }));
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setForm((prevForm) => ({ ...prevForm, [name]: value }));
        console.log(value)
    };

    const handleSubmit = async () => {
        try {
            editing ? await Conect.put("/dmVoaWNsZXVwZGF0ZQ==", form) : await Conect.post("/dmVoaWNsZWNyZWF0", form);
            fetchVehicles();
            closeModal();
        } catch (error) {
            console.error(`Error ${editing ? "updating" : "creating"} vehicle:`, error);
        }
    };

    const handleDeleteVehicle = async (id) => {
        try {
            await Conect.delete("/ZGVsZXRldmVoaWNsZQ==", { data: { id } });
            fetchVehicles();
        } catch (error) {
            console.error("Error deleting vehicle:", error);
        }
    };

    const openModal = (vehicle = null) => {
        setForm(vehicle ? vehicle : initialFormState);
        setEditing(!!vehicle);
        setShowModal(true);
    };

    const closeModal = () => setShowModal(false);

    return (
        <>
            {showModal && (
                <div className="vehicle-modal">
                    <div className="vehicle-modal-content">
                        <h3>Adicionar/Editar Veículo</h3>
                        <div className="vehicle-modal-grid">
                            {/* Linha 1: Informações Básicas - Placa, Ano e Marca */}
                            <div style={{ display: "flex", gap: "10px" }}>
                                <div style={{ flex: 1 }}>
                                    <label htmlFor="plate">Placa</label>
                                    <input
                                        id="plate"
                                        type="text"
                                        name="plate"
                                        placeholder="Placa"
                                        value={form.plate}
                                        onChange={handleInputChange}
                                    />
                                </div>
                                <div style={{ flex: 1 }}>
                                    <label htmlFor="year">Ano</label>
                                    <input
                                        id="year"
                                        type="text"
                                        name="year"
                                        placeholder="Ano"
                                        value={moment(form.year).format("YYYY")}
                                        onChange={handleInputChange}
                                    />
                                </div>
                                <div style={{ flex: 1 }}>
                                    <label htmlFor="brand">Marca</label>
                                    <input
                                        id="brand"
                                        type="text"
                                        name="brand"
                                        placeholder="Marca"
                                        value={form.brand}
                                        onChange={handleInputChange}
                                    />
                                </div>
                            </div>

                            {/* Linha 2: Modelo e Descrição */}
                            <div style={{ display: "flex", gap: "10px" }}>
                                <div style={{ flex: 1 }}>
                                    <label htmlFor="model">Modelo</label>
                                    <input
                                        id="model"
                                        type="text"
                                        name="model"
                                        placeholder="Modelo"
                                        value={form.model}
                                        onChange={handleInputChange}
                                    />
                                </div>
                                <div style={{ flex: 2 }}>
                                    <label htmlFor="description">Descrição</label>
                                    <input
                                        id="description"
                                        type="text"
                                        name="description"
                                        placeholder="Descrição"
                                        value={form.description}
                                        onChange={handleInputChange}
                                    />
                                </div>
                            </div>

                            {/* Linha 3: Odômetro */}
                            <div style={{ display: "flex", gap: "10px" }}>
                                <div style={{ flex: 1 }}>
                                    <label htmlFor="odometer">Odômetro</label>
                                    <input
                                        id="odometer"
                                        type="number"
                                        name="odometer"
                                        placeholder="Odômetro"
                                        value={form.odometer}
                                        onChange={handleInputChange}
                                    />
                                </div>
                            </div>

                            {/* Linha 4: Seleções Relacionadas - Cliente, Motorista, Equipamento e Tipo */}
                            <div style={{ display: "flex", gap: "20px", flexWrap: "wrap" }}>
                                <div style={{ flex: 1, minWidth: "200px" }}>
                                    <label htmlFor="customers_id">Cliente</label>
                                    <select
                                        id="customers_id"
                                        name="customers_id"
                                        value={form.customers_id || ""}
                                        onChange={handleInputChange}
                                    >
                                        <option value="">Selecione um Cliente</option>
                                        {clients.map((client) => (
                                            <option key={client.id} value={client.id}>
                                                {client.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div style={{ flex: 1, minWidth: "200px" }}>
                                    <label htmlFor="driver_id">Motorista</label>
                                    <select
                                        id="driver_id"
                                        name="driver_id"
                                        value={form.driver_id || ""}
                                        onChange={handleInputChange}
                                    >
                                        <option value="">Selecione um Motorista</option>
                                        {drivers.map((driver) => (
                                            <option key={driver.id} value={driver.id}>
                                                {driver.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div style={{ flex: 1, minWidth: "200px" }}>
                                    <label htmlFor="equipament_id">Equipamento</label>
                                    <select
                                        id="equipament_id"
                                        name="equipament_id"
                                        value={form.equipament_id || ""}
                                        onChange={handleInputChange}
                                    >
                                        <option value="">Selecione um Equipamento</option>
                                        {equips.map((equip) => (
                                            <option key={equip.id} value={equip.id}>
                                                {equip.serial}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div style={{ flex: 1, minWidth: "200px" }}>
                                    <label htmlFor="vehicle_type">Tipo de Veículo</label>
                                    <select
                                        id="vehicle_type"
                                        name="vehicle_type"
                                        value={form.vehicle_type || ""}
                                        onChange={handleInputChange}
                                    >
                                        <option value="">Selecione um Tipo de Veículo</option>
                                        {vehicleTypes.map((type) => (
                                            <option key={type.id} value={type.id}>
                                                {type.description}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className="vehicle-modal-actions">
                            <button className="vehicle-btns-block" onClick={handleSubmit}>Salvar</button>
                            <button className="vehicle-btns-block" onClick={closeModal}>Cancelar</button>
                        </div>
                    </div>
                </div >
            )}

            <div className="vehicles-manager">
                <h2>Gerenciamento de Veículos</h2>
                <button className="vehicle-btns-block" onClick={() => openModal()}>Adicionar Veículo</button>

                <table className="vehicles-table">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Placa</th>
                            <th>Descrição</th>
                            <th>Ano</th>
                            <th>Modelo</th>
                            <th>Marca</th>
                            <th>Odômetro</th>
                            <th>Cliente</th>
                            <th>Equip.</th>
                            <th>Tipo</th>
                            <th>Atualizado</th>
                            <th>Criado</th>
                            <th>Ações</th>
                        </tr>
                    </thead>
                    <tbody>
                        {vehicles.map((vehicle) => (
                            <tr key={vehicle.id}>
                                <td>{vehicle.id}</td>
                                <td>{vehicle.plate}</td>
                                <td>{vehicle.description}</td>
                                <td>{moment(vehicle.year).format('YYYY')}</td>
                                <td>{vehicle.model}</td>
                                <td>{vehicle.brand}</td>
                                <td>{vehicle.odometer}</td>
                                <td>{vehicle.cli_name}</td>
                                <td>{vehicle.serial}</td>
                                <td>{vehicle.type}</td>
                                <td>{vehicle.updated_at ? moment(vehicle.updated_at).format("DD/MM/YYYY HH:mm:ss") : "--"}</td>
                                <td>{moment(vehicle.created_at).format("DD/MM/YYYY HH:mm:ss")}</td>
                                <td>
                                    <button className="vehicle-btns-block" onClick={() => openModal(vehicle)}>Editar</button>
                                    <button className="vehicle-btns-block" style={{ marginLeft: '2%' }} onClick={() => handleDeleteVehicle(vehicle.id)}>Remover</button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </>
    );
};

export default VehiclesManager;
